// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.nav-item {
  color: #fff;
}

.nav-item.active {
  /*border-bottom: 3px solid rgba(255, 213, 79, 0.8);*/
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsY0FBYztFQUNkLFlBQVk7QUFDZDs7QUFFQTtFQUNFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLG9EQUFvRDtBQUN0RCIsImZpbGUiOiJhcHAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG4gIGhlaWdodDogMTAwJTtcbn1cblxuLm5hdi1pdGVtIHtcbiAgY29sb3I6ICNmZmY7XG59XG5cbi5uYXYtaXRlbS5hY3RpdmUge1xuICAvKmJvcmRlci1ib3R0b206IDNweCBzb2xpZCByZ2JhKDI1NSwgMjEzLCA3OSwgMC44KTsqL1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oDAAoD;AACtD;;AAEA,ghBAAghB","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.nav-item {\n  color: #fff;\n}\n\n.nav-item.active {\n  /*border-bottom: 3px solid rgba(255, 213, 79, 0.8);*/\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
